export function TermsOfServiceStructuredData() {
  const baseUrl = "https://beatview.ai";

  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: baseUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Terms of Service",
        item: `${baseUrl}/terms-of-service`,
      },
    ],
  };

  const webPage = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Terms of Service - Beatview",
    description:
      "Review the terms and conditions for using Beatview's AI-powered recruitment platform. Understand your rights and responsibilities as a user.",
    url: `${baseUrl}/terms-of-service`,
    isPartOf: {
      "@type": "WebSite",
      name: "Beatview",
      url: baseUrl,
    },
    publisher: {
      "@type": "Organization",
      name: "Beatview",
      url: baseUrl,
    },
    dateModified: "2026-01-29",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbList) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPage) }}
      />
    </>
  );
}
